<template>
  <div id="dashboard-page">
    <b-card class="mb-5">
      <b-row>
        <b-col md="10">
          <h3>{{$route.name}}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
      <div class="border-bottom mb-5"></div>
      <table class="table table-hovered table-striped">
        <thead>
          <tr>
            <th>Plate</th>
            <th>Issued By</th>
            <th>Issued Date</th>
            <!-- <th>Repair Date</th> -->
            <th>Amount</th>
            <!-- <th>Paid Date</th> -->
            <th class="text-center">Status</th>
            <th></th>
          </tr>
        </thead>
        <template v-if="isLoading">
          <tbody>
            <tr>
              <td colspan="10" class="text-center"><b-spinner variant="primary" label="Spinning"></b-spinner></td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <tbody v-if="vehicleRepairList.length > 0">
            <tr v-for="(repair, index) in vehicleRepairList" :key="index">
              <td>{{repair.vehicle.plate}}</td>
              <td>{{repair.issuedBy}}</td>
              <td>{{getDateTime(repair.createdAt)}}</td>
              <!-- <td>{{getDateTime(repair.dueDate)}}</td> -->
              <td>{{ dataAccount.account.currency }} {{formatPrice(repair.amount)}}</td>
              <!-- <td>{{getDateTime(repair.paidDate)}}</td> -->
              <td class="text-center">
                <div :id="'btn-popover-payment-'+ index">
                  <b-badge :variant="getStatusColor(repair.status)">{{getStatusName(repair.status)}}</b-badge>
                </div>
              </td>
              <td>
                <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/vehicle/repair-detail/' + repair.uuid"></a>
                <!-- <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + payment.uuid + '?status=' + payment.status"></a> -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9" class="text-center">There's no data</td>
            </tr>
          </tbody>
        </template>
      </table>
      <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
    </b-card>
  </div>
</template>

<script>
  import PaginatedTable from '@/components/PaginatedTable'
  export default {
    components: {
      PaginatedTable
    },
    data () {
      return {
        isLoading: false,
        dataAccount: this.$store.getters['account/accountData'],
        apiUrl: {
          repair: window.AppConfig.apiUrl + 'vehicle-bill-info?type=Repair&status=New'
        },
        vehicleRepairList: []
      }
    },
    mounted () {
      this.getRepairData()
    },
    methods: {
      getRepairData () {
        this.isLoading = true
        this.$http.get(this.apiUrl.repair).then(response => {
          if (response.data._embedded.vehicleBillInfo) {
            const registeredPlate = [];
            this.vehicleRepairList = response.data._embedded.vehicleBillInfo.filter(item => {
              this.isLoading = false
              if (registeredPlate.includes(item.vehicle.plate)) return false; 
              
              registeredPlate.push(item.vehicle.plate);
              return true
            })
          }
        })
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD')
        } else {
          return '-'
        }
      },
      getStatusColor (val) {
        switch (val) {
        case 'New':
          return 'secondary'
          // eslint-disable-next-line no-unreachable
          break
        }
      },
      getStatusName (val) {
        switch (val) {
        case 'New':
          return 'Requested'
          // eslint-disable-next-line no-unreachable

          break
        }
      },
      goBack () {
        window.goBack(this)
      }
    }
  }
</script>